import React from 'react';
import { Shirt, Sparkles, Camera } from 'lucide-react';

const cards = {
  en: [
    {
      icon: Shirt,
      title: 'Fashion studio',
      desc: 'Read a cut, layer colour and build outfits for your figure and the occasion.',
    },
    {
      icon: Sparkles,
      title: 'Beauty bar',
      desc: 'Skin, brows and makeup, explained so the look stays calm under studio light.',
    },
    {
      icon: Camera,
      title: 'Model presence',
      desc: 'Gaze, stance and expression in short sequences you can repeat in the mirror.',
    },
  ],
  de: [
    {
      icon: Shirt,
      title: 'Modeatelier',
      desc: 'Schnitte lesen, Farben schichten und Outfits für Figur und Anlass bauen.',
    },
    {
      icon: Sparkles,
      title: 'Beautybar',
      desc: 'Haut, Brauen und Make-up, erklärt so, dass der Look unter Studiolicht ruhig bleibt.',
    },
    {
      icon: Camera,
      title: 'Modelpräsenz',
      desc: 'Blick, Stand und Ausdruck in kurzen Sequenzen, die du vor dem Spiegel wiederholst.',
    },
  ],
};

export default function Benefits({ lang }) {
  const t = {
    headline: lang === 'de' ? 'WAS MODELCAMP DIR ZEIGT' : 'WHAT MODELCAMP SHOWS YOU',
    sub:
      lang === 'de'
        ? 'Konkrete Übungen zu Mode, Beauty und Präsenz, ohne Agenturversprechen.'
        : 'Concrete exercises in fashion, beauty and presence, without agency promises.',
  };

  return (
    <section className="bg-[#faf7f4] py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-rose-100 text-rose-900 text-xs font-bold uppercase tracking-widest rounded-full mb-4">
            {lang === 'de' ? 'Disziplinen' : 'Disciplines'}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-stone-900 tracking-tight">
            {t.headline}
          </h2>
          <p className="mt-4 text-lg text-stone-500 max-w-xl mx-auto">{t.sub}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards[lang].map(({ icon: Icon, title, desc }, i) => (
            <div
              key={i}
              className="group flex flex-col items-start gap-5 bg-white rounded-2xl p-7 border border-stone-200 shadow-sm hover:shadow-xl hover:border-rose-200 hover:scale-[1.02] transition-all duration-300"
            >
              <div className="w-14 h-14 rounded-2xl bg-stone-900 group-hover:bg-rose-950 flex items-center justify-center shadow-md transition-colors duration-300">
                <Icon size={26} color="white" strokeWidth={2} />
              </div>

              <div>
                <h3 className="text-xl font-bold text-stone-900 mb-2">{title}</h3>
                <p className="text-stone-500 leading-relaxed">{desc}</p>
              </div>

              <div className="mt-auto pt-2">
                <a
                  href="/s"
                  className="text-xs font-semibold text-rose-900 uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                  {lang === 'de' ? 'Zum Atelier' : 'To the atelier'}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
